<script setup>
import { ref } from 'vue'
import DateFilter from './DateFilter.vue'
import { beforeEnter, enter, beforeLeave, leave } from '@/helpers/slideUp.js'
import { useCommonStore } from '@/stores/CommonStore'
import { PlusIcon, MinusSmallIcon as MinusSmIcon } from '@heroicons/vue/24/solid';
import FilterListBox from '@/components/FilterListBox.vue'

const commonStore = useCommonStore()

// eslint-disable-next-line no-unused-vars
const props = defineProps(['commonStore', 'siteConfig', 'filterDropdowns', 'haveActiveFilters', 'filterSummary', 'resetFilters', 'filterValues', 'dateRange', 'clearDates', 'applyDates'])


const showClassFilters = ref(false)

// const showClassFilters = defineModel<boolean>('showClassFilters', { required: true })
</script>

<template>
  <transition
    name="accordion"
    @before-enter="beforeEnter"
    @enter="enter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <div
      class="classes-filters md:grid-cols-2"
      :class="{
        'xl:grid-cols-3': siteConfig.features.classFilters?.columns == 3 || !siteConfig.features.classFilters?.columns,
        'xl:grid-cols-4': siteConfig.features.classFilters?.columns == 4,
        'xl:grid-cols-5': siteConfig.features.classFilters?.columns == 5,
      }"
      v-if="showClassFilters || commonStore.windowInnerWidth > 768"
    >
      <FilterListBox
        v-for="dropdown in filterDropdowns"
        v-model="dropdown.selectedItem"
        :options="dropdown.options"
        :placeholder="dropdown.placeholder || dropdown.options[0]"
        @update:model-value="dropdown.update"
        :display-value="dropdown.displayValue"
        :option-display="dropdown.optionDisplay"
        :option-value="dropdown.optionValue"
        searchable
      />
      
      <DateFilter :dateRange="dateRange" :clearDates="clearDates" :applyDates="applyDates" />
    </div>
  </transition>
			  

  <button
    class="btn-show-filters"
    @click="showClassFilters = !showClassFilters"
  >
    <MinusSmIcon class="icon" v-if="showClassFilters" />
    <PlusIcon class="icon" v-else />
    {{ showClassFilters ? 'Hide Filters' : 'Show Filters' }}
  </button>
	
  <p v-if="haveActiveFilters" class="mb-10 w-full">
    <span v-html="filterSummary"></span>
    <button @click="resetFilters" class="text-accent-1 font-bold pl-4">
      ✕&nbsp;&nbsp;{{
        filterValues.length == 1 ? 'Clear Filter' : 'Clear Filters'
      }}
    </button>
  </p>
</template>

<style lang="pcss" scoped>
.btn-show-filters {
	@apply inline-flex items-center gap-x-1.5 mb-8 text-accent-1 font-bold text-sm md:hidden;
	.icon {
		@apply w-4 h-4;
	}
}
.classes-filters {
	@apply grid gap-y-3 gap-x-5 xl:gap-x-4 mb-4 md:mb-0 md:pb-10 transition-all duration-200;
	@screen md {
		height: fit-content !important;
	}
	.date-filter {
		@apply md:hidden mt-5;
		@media (min-width: 450px) { .filters-wrapper { @apply flex gap-x-5 mb-3 } }
		.input-component {
		@apply flex-1;
		.form-control {
			display: block !important;
			min-width: calc(100% - 16px) !important;
			min-height: 44px !important;
			height: 44px !important;
			-webkit-min-logical-width: calc(100% - 16px) !important;
			padding-top: 0.5rem !important;
			padding-bottom: 0.5rem !important;
			line-height: 44px !important;
			vertical-align: middle !important;
		}
		}
		.filter-actions {
		@apply flex gap-x-4;
		button { @apply flex-1 py-2 }
		}
	}
}

</style>
